export enum ProvisionTypeApis {
   CloudSql = 'CloudSql',
   NetApp = 'NetApp',
   Mad = 'Mad'
}
